var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_1017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 10.2858H13.7143V13.3332C13.7135 14.0402 13.4323 14.7179 12.9325 15.2179C12.4327 15.7178 11.7549 15.9991 11.048 16.0001H2.66629C1.95934 15.9991 1.28163 15.7178 0.781795 15.2179C0.281959 14.7179 0.000806328 14.0402 0 13.3332L0 4.95265C0.000791928 4.2457 0.281939 3.56791 0.781775 3.06797C1.28161 2.56802 1.95933 2.28672 2.66629 2.28577H5.71429V4.57148H2.66629C2.5653 4.57164 2.4685 4.61187 2.39714 4.68333C2.32579 4.7548 2.28571 4.85166 2.28571 4.95265V13.3332C2.28573 13.4342 2.32581 13.531 2.39716 13.6025C2.46852 13.674 2.56531 13.7142 2.66629 13.7143H11.048C11.149 13.7142 11.2458 13.674 11.3171 13.6025C11.3885 13.531 11.4286 13.4342 11.4286 13.3332V10.2858Z",
    fill: "#F58120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 10.2858H13.7143V13.3332C13.7135 14.0402 13.4323 14.7179 12.9325 15.2179C12.4327 15.7178 11.7549 15.9991 11.048 16.0001H2.66629C1.95934 15.9991 1.28163 15.7178 0.781795 15.2179C0.281959 14.7179 0.000806328 14.0402 0 13.3332L0 4.9526C0.000806328 4.24565 0.281959 3.56788 0.781795 3.06795C1.28163 2.56801 1.95934 2.28672 2.66629 2.28577H5.71429V4.57148H2.66629C2.56531 4.57164 2.46852 4.61186 2.39716 4.68332C2.32581 4.75477 2.28573 4.85162 2.28571 4.9526V13.3332C2.28573 13.4342 2.32581 13.531 2.39716 13.6025C2.46852 13.674 2.56531 13.7142 2.66629 13.7143H11.048C11.149 13.7142 11.2458 13.674 11.3171 13.6025C11.3885 13.531 11.4286 13.4342 11.4286 13.3332V10.2858Z",
    fill: "#F58120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 0V2.28571H12.0982L4.90625 9.47771L6.52236 11.0938L13.7143 3.90182V8H16V1.14286C16 0.839753 15.8796 0.549062 15.6653 0.334735C15.451 0.120408 15.1603 0 14.8572 0L8.00002 0Z",
    fill: "#1E334E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 0V2.28571H12.0982L4.90625 9.47766L6.52236 11.0938L13.7143 3.90177V8H16V1.14286C16 0.839753 15.8796 0.549062 15.6653 0.334735C15.451 0.120408 15.1603 0 14.8572 0L8.00002 0Z",
    fill: "#1E334E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_1017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsExternalLink);
export default __webpack_public_path__ + "static/media/WHSExternalLink.fcf0db9bfd6562f23f6a5c31030a9066.svg";
export { ForwardRef as ReactComponent };